module.exports = __webpack_public_path__ + "static/media/EVAN_logo_square.a9a91598.png";